import { render, staticRenderFns } from "./HoldModal.vue?vue&type=template&id=b167d266&scoped=true"
import script from "./HoldModal.vue?vue&type=script&lang=js"
export * from "./HoldModal.vue?vue&type=script&lang=js"
import style0 from "./HoldModal.vue?vue&type=style&index=0&id=b167d266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b167d266",
  null
  
)

export default component.exports